import { PropsWithChildren, createContext } from "react";
import { ApiClient } from "./api-client.service";

export interface ApiContextType {
  api: ApiClient;
}

export const ApiContext = createContext<ApiContextType | undefined>(undefined);

interface ApiProviderProps extends ApiContextType {}

export function ApiProvider({
  children,
  ...apis
}: PropsWithChildren<ApiProviderProps>) {
  return <ApiContext.Provider value={apis}>{children}</ApiContext.Provider>;
}
